export default "__VITE_ASSET__DcbcL2DA__"